import React from "react";
import img1 from "../../../Assets/ISO Certification/img1.png";
import img2 from "../../../Assets/ISO Certification/img2.png";
import img3 from "../../../Assets/ISO Certification/img3.png";

const ISOSpecifications27001 = () => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 p-10">
        {/* right side content  */}
        <div className="w-full text-[#032303] font-medium sm:text-3xl md:font-medium text-md lg:text-3xl xl:text-4xl">
          <h1 className="mb-3">
            <span className="border-b-4 border-[#249742]"> ISO 270</span>
            01:2011 Specifications :
          </h1>

          <div className="py-4 lg:py-8 space-y-2">
            <ol className="list-decimal ml-5 text-xs md:text-lg py-4 text-[#4D4D4D]">
              <li>
                Management system of an organization should systematically
                analyze the risk involved in an organization’s information
                security considering the threats, vulnerabilities and its
                effects.
              </li>
              <li className="py-2">
                Management System of an organization should plan and implement a
                reasonable and a complete risk management system as well as
                suite of information security controls to tackle the
                unacceptable risks that may occur, and
              </li>
              <li className="py-2">
                A organization should acquire an overall management process to
                make sure that the information security controls continue to
                meet the organization’s information security needs continuously.
              </li>
            </ol>
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              Technical security controls such as antivirus and firewalls are
              not normally audited in ISO/IEC 27001 certification auditsand its
              is is essentially presumed that the organization have acquired all
              mandatory information security controls since the overall ISMS is
              in place and is deemed adequate by satisfying the requirements of
              ISO/IEC 27001.
            </p>
          </div>
        </div>

        {/* left side images  */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex flex-col items-end gap-4 justify-end w-full">
            <div className="w-full lg:w-auto">
              {" "}
              <img src={img1} alt="" className="rounded-lg w-full lg:w-auto" />
            </div>
            <div className="w-full lg:w-auto">
              {" "}
              <img src={img2} alt="" className="rounded-lg w-full lg:w-auto" />
            </div>
          </div>
          <div className="h-full">
            <img src={img3} alt="" className="rounded-lg h-full" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOSpecifications27001;
